var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../common/components/base.component';
import { HubComponent } from '../hub.component';
var ManuallyAddComponent = /** @class */ (function (_super) {
    __extends(ManuallyAddComponent, _super);
    function ManuallyAddComponent(router, activatedRoute, parent) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.parent = parent;
        return _this;
    }
    ManuallyAddComponent.prototype.ngOnInit = function () {
        var hubName = this.allRouteParams.hubName;
        this.parent.location = 'SUBMIT EVENT OR PLACE MANUALLY';
        this.hubName = hubName;
    };
    return ManuallyAddComponent;
}(BaseComponent));
export { ManuallyAddComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/manually.add/manually.add.component.ts.pre-build-optimizer.js